/**
 * Project : workspace
 * File    : StoreDetailScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.customer.store

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.cart.viewModel.CartViewModel
import com.parmartechnologies.commerce.feature.customer.viewModel.CustomerViewModel
import com.parmartechnologies.commerce.feature.inventory.product.viewModel.ProductViewModel
import com.parmartechnologies.commerce.feature.inventory.productCategory.viewModel.ProductCategoryViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.inventory.InventoryViewModel
import com.parmartechnologies.commerce.feature.offerBanner.viewModel.OfferBannerViewModel
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.navigation.NavigationParam
import component.navigation.TopNavBar
import component.offers.OfferBannerList
import component.product.ProductCard
import navigation.AppNavigator
import navigation.commerce.route.home.CommerceHomeNavRoute
import presentation.screens.customer.store.component.CartFooter
import presentation.screens.customer.store.component.StoreCategory
import presentation.screens.customer.store.component.StoreHeader
import presentation.screens.customer.store.component.loading.storeLoadingScreen
import theme.ThemeColor

/**
 * Represents the store detail screen class.
 */

class StoreDetailScreen {
    @Composable
    fun Content() {
        val params = AppNavigator.shared().getNavigationParam()
        val viewModel = BusinessViewModel()
        val selectedBusiness = viewModel.selectedBusiness.collectAsState()
        LaunchedEffect(Unit) {
                viewModel.loadBusinessById(params._id){busin->
                    viewModel.setSelectedBusiness(busin!!)
                }
        }
        if(selectedBusiness.value._id.isNotEmpty()){
            storeDetails(selectedBusiness.value)
        }else{
            storeLoadingScreen()
        }

    }

    @Composable
    /**
 * Executes the store details operation.
 *
 * @receiver TODO
 * @param business The business.
 * @return Unit – no return value.
 */
    fun storeDetails(business:Business) {
        val viewModel = BusinessViewModel()
        val customerViewModel = CustomerViewModel(business = business)
        val authViewModel = AuthViewModel()
        val cartViewModel = CartViewModel(business = business)
        val offerBannerViewModel = OfferBannerViewModel(business = business)
        val productViewModel = ProductViewModel(business = business)
        val categoryViewModel = ProductCategoryViewModel(business = business)
        val inventoryViewModel = InventoryViewModel(business = business)
        val allBanners = offerBannerViewModel.allData.collectAsState()
        val customer = customerViewModel.customer.collectAsState()
        val products = productViewModel.products.collectAsState()
        val user = authViewModel.authUser.collectAsState()
        val allCategory = categoryViewModel.allCategory.collectAsState()
        val searchQuery = productViewModel.searchQuery.collectAsState()
        val navigationParam = AppNavigator.shared().getNavigationParam()
        LaunchedEffect(business) {
            navigationParam.selectedBusiness = business
            viewModel.loadSelectedStore(bus = business) { business ->
                navigationParam.business = business!!
                offerBannerViewModel.retrieve()
                productViewModel.loadProductForBusiness(business._id)
                categoryViewModel.retrieveForBusiness(business._id)
                inventoryViewModel.loadInventoryForBusiness(business._id)
                cartViewModel.loadCart(navigationParam) { its ->
                    print(its)
                }
            }
            customerViewModel.loadMembership(
                mobile = user.value.MobileNumber, dialCode = user.value.DialCode
            )
        }
        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)
        ) {
//            if (hideBack) {
            TopNavBar(title = "", navigationParam)
//            } else {
//                TopNavBar(title = "", NavigationParam(), onBackPress = {
//                    AppNavigator.shared().goBack()
//                })
//            }
//            AppLoader(productViewModel)
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 160.dp),
                modifier = Modifier.weight(1f).padding(
                    start = 0.dp,
                    end = 0.dp,
                ),
            ) {
                item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                    StoreHeader(business, productViewModel, searchQuery.value)
                }
                item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                    OfferBannerList(allBanners.value)
                }
                item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                    Column {
                        if (customer.value?._id?.isNotEmpty() == true) {
                            Spacer(modifier = Modifier.height(15.dp))
//                            MembershipRow(
//                                viewModel = customerViewModel,
//                                authViewModel = authViewModel
//                            )
                            Spacer(modifier = Modifier.height(15.dp))
                        }
                    }
                }

                item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                    StoreCategory(allCategory)
                }
                items(products.value.count()) { index ->
                    ProductCard(
                        products.value[index],
                        cartViewModel,
                        navigationParam,
                        onClick = { product ->
                            navigationParam.product = product
                            AppNavigator.shared()
                                .navigate(CommerceHomeNavRoute.PRODUCT, navigationParam)
                        }).content()
                }
            }
            CartFooter(NavigationParam(), viewModel = cartViewModel) {
                if (AuthHandler.shared().isLoggedIn()) {
                    AppNavigator.shared().navigate(CommerceHomeNavRoute.SHOPPING_CART,navigationParam)
                } else {
                    AuthViewModel().showAuthContainer()
                }
            }
        }
    }
}


